import api from './api';

const questionService = {
  getByProduct: (productId, params) => api.get(`/products/${productId}/questions`, { params }),
  ask: (productId, body) => api.post(`/products/${productId}/questions`, { body }),
  answer: (productId, questionId, body) =>
    api.post(`/products/${productId}/questions/${questionId}/answers`, { body }),
};

export default questionService;
